import { CSS_PROPERTY, getCssBasedOnRtl } from '../../styles';
import { DEFAULT_SEPARATOR } from '../../styles/sc-vars';
import styled from 'styled-components';

export const DenyLink = styled.div`
  font-size: 12px;
  font-weight: 500;
  margin-right: ${({ theme }) => theme.spacing.base.xxs};
  margin-left: ${({ theme }) => theme.spacing.base.xxs};
  display: flex;
  align-items: center;
`;

export const DenyLinkWrapper = styled.div`
  color: ${({ theme }) => theme.ui.links.fontColor};
  cursor: pointer;
  display: inline-flex;
  padding: ${({ theme }) => `${theme.spacing.base.sm} ${theme.spacing.base.xl}`};
  svg path {
    fill: ${({ theme }) => theme.ui.links.fontColor};
  }
`;

export const Wrapper = styled.div`
  border-bottom: ${DEFAULT_SEPARATOR};
  border-radius: ${({ theme }) => theme.ui.layer.borderRadius} ${({ theme }) => theme.ui.layer.borderRadius} 0 0;
  display: flex;
  ${({ theme }) => getCssBasedOnRtl(theme, CSS_PROPERTY.FLEX_ALIGNMENT_RIGHT, 0)};
`;

export const RightIcon = styled.div`
  display: ${({ theme }) => (theme.typography.rtlEnabled ? 'none' : 'inline-flex')};
  height: 16px;
`;

export const LeftIcon = styled.div`
  display: ${({ theme }) => (theme.typography.rtlEnabled ? 'inline-flex' : 'none')};
  height: 16px;
  order: ${({ theme }) => (theme.typography.rtlEnabled ? 1 : 0)};
`;
